var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "header",
        [
          _vm._t("default"),
          _vm._v(" "),
          !_vm.empty && _vm.cluster
            ? _c("ButtonSwitch", {
                attrs: {
                  options: {
                    heatmap: _vm.$t("swee:dashboard.map.heatmap"),
                    markers: _vm.$t("swee:dashboard.map.markers")
                  }
                },
                model: {
                  value: _vm.mapView,
                  callback: function($$v) {
                    _vm.mapView = $$v
                  },
                  expression: "mapView"
                }
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.empty && _vm.loaded
        ? _c("div", [_vm._v(_vm._s(_vm._f("trans")("no_count")))])
        : _vm._e(),
      _vm._v(" "),
      _vm.empty && !_vm.loaded ? _c("Loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { ref: "map", staticClass: "map" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c6974c4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6974c4e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/helpers/components/display/Map.vue
// module id = null
// module chunks = 